module.exports = __webpack_public_path__ + "img/image_header-pc.0ac9828d.png";